/**
 * History shape for `/games/:gameModeId` and `/` when navigating inside the SPA.
 *
 * Cold loads / external URLs do not set this flag; programmatic navigations pass
 * `state: { boggleAutoStartStandardRun: true }` (see TanStack Router
 * NavigateOptions [`state`](https://tanstack.com/router/latest/docs/framework/react/api/router/NavigateOptionsType)).
 */
export type BoggleGamesRouteHistoryState = {
  boggleAutoStartStandardRun?: boolean
}

export function readBoggleGamesAutoStartFromHistoryState(state: unknown) {
  if (typeof state !== 'object' || state === null) {
    return false
  }

  const candidate = state as Record<string, unknown>
  return candidate.boggleAutoStartStandardRun === true
}
